import { type SelectProps } from 'antd';
import { useMemo } from 'react';
import { type RoleListDataFragment } from '../../api/fragments/RoleListData';
import { useListRolesQuery } from '../../api/queries/listRoles';
import { useCompany } from '../contexts/CompanyContextManager';
import SelectField, { type SelectFieldProps } from './SelectField';

export type RoleSelectFieldProps = Omit<SelectFieldProps, 'children'> & {
    roles?: RoleListDataFragment[];
    companyId?: string;
};

const filterOption: SelectProps['filterOption'] = (inputValue, option) =>
    option.label.toString().toLowerCase().includes(inputValue.toLowerCase());

const RoleSelectField = ({ roles: rolesFromProps, companyId, ...props }: RoleSelectFieldProps) => {
    // get company context
    const company = useCompany(true);

    const { data, loading } = useListRolesQuery({
        fetchPolicy: 'cache-and-network',
        variables: { filter: { companyId: company?.id } },
        skip: !!rolesFromProps,
    });

    const roles = useMemo(() => rolesFromProps || data?.page?.items || [], [data?.page?.items, rolesFromProps]);
    const options = roles.map(role => ({
        value: role.id,
        key: role.id,
        label: role.displayName,
    }));

    return <SelectField {...props} filterOption={filterOption} loading={!roles && loading} options={options} />;
};

export default RoleSelectField;
